
import { formatNumber } from "src/MarketDataComponents/Helpers";
import moment from 'moment-timezone';

export default function Nav({quote, keyStatistics}) {

    const getLatestNavDate = () => {
        return moment(quote.latestNavDate).format('DD MMMM YYYY')
    }

    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
            <h2 className="card-title" data-testid="netAssetValueHeader">Net asset value (NAV)</h2>
            <table className="data-table data-table--small data-table--scroll margin-0">
                <tbody>
                    <tr>
                        <th scope="row" className="font-weight-bold" data-testid="estimatedNavLabel">Estimated NAV</th>
                        <td aria-label="" data-testid="estimatedNavValue">{formatNumber(quote.estimatedNavPrice, 2)}</td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-bold" data-testid="latestActualNavLabel">Latest actual NAV</th>
                        <td aria-label="" data-testid="latestActualNavValue">{quote.latestNavPrice ? formatNumber(quote.latestNavPrice, 2) : '-'}</td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-bold" data-testid="latestActualNavDateLabel">Latest actual NAV date</th>
                        <td aria-label="" data-testid="latestActualNavDateValue">{getLatestNavDate()}</td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-bold" data-testid="mAveragePremiumDiscountLabel">12m average premium/discount</th>
                        <td aria-label="" data-testid="mAveragePremiumDiscountValue">{keyStatistics && keyStatistics.averageDiscountM12 ? keyStatistics.averageDiscountM12 + '%' : '-'}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

}